import * as React from "react";
import CellDropDown from "./CellDropDown";
import { rankItem } from "@tanstack/match-sorter-utils";

import {
  useReactTable,
  getCoreRowModel,
  getFilteredRowModel,
  getSortedRowModel,
  flexRender,
} from "@tanstack/react-table";

import { useState } from "react";
import MirageLoader from "../../ui/pageLoader/MirageLoader";

const fuzzyFilter = (row, columnId, value, addMeta) => {
  const itemRank = rankItem(row.getValue(columnId), value);

  addMeta({
    itemRank,
  });

  return itemRank.passed;
};
const AssignPermTable = (props) => {
  const {
    tableData,
    columns,
    setIsDelete,
    setSelectedItemId,
    rowId,
    isDropDownVisible,
    buttonConfig,
    edited,
    setEdited,
    setRowEdit,
    rowEdit,
    isButtonClicked,
  } = props;

  const [data, setData] = React.useState([]);
  const [globalFilter, setGlobalFilter] = React.useState("");
  const [payloadChanges, setPayloadChange] = useState([]);

  const customTable = useReactTable({
    data,
    columns,
    filterFns: {
      fuzzy: fuzzyFilter,
    },
    state: {
      globalFilter,
    },
    onGlobalFilterChange: setGlobalFilter,
    globalFilterFn: fuzzyFilter,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
  });

  const editHandler = buttonConfig.editMenuPermission;

  const handleEditButton = async () => {};

  const handleSubmit = async () => {
    if (payloadChanges.length > 0) {
      await editHandler(payloadChanges[0]);
    }
  };

  React.useEffect(() => {
    if (edited) {
      setPayloadChange([]);
    }
  }, [edited]);

  React.useEffect(() => {
    if (customTable.getState().columnFilters[0]?.id === "fullName") {
      if (customTable.getState().sorting[0]?.id !== "fullName") {
        customTable.setSorting([{ id: "fullName", desc: false }]);
      }
    }
  }, [customTable.getState().columnFilters[0]?.id]);

  React.useEffect(() => {
    if (tableData) setData(tableData);
  }, [tableData]);

  if (!data) return null;

  return (
    <div className="">
      <div className="scrollbar-custom relative max-xl:overflow-x-scroll">
        <table className="mt-[20px] w-full max-xl:overflow-x-scroll ">
          <thead className="bg-pri-clr-blue">
            {customTable.getHeaderGroups().map((headerGroup) => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map((header, index) => (
                  <th
                    key={header.id}
                    className={` border-1 w-fit whitespace-nowrap border-black px-1 py-2 text-start text-[12px] font-bold uppercase text-[#F6F6F6]`}
                  >
                    {header.isPlaceholder
                      ? null
                      : flexRender(
                          header.column.columnDef.header,
                          header.getContext(),
                        )}
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <thead className="h-2">
            <tr></tr>
          </thead>
          {/* {isLoading && <ComponentLoader percentage={isLoading} />} */}

          <tbody className="border-[1px] border-neutral-clr-300 pt-2">
            {customTable.getRowModel().rows.map((row) => (
              // <tr key={row.id}>
              <tr
                key={row.id}
                className={
                  rowId?.row?.id === row.id && isDropDownVisible
                    ? "bg-gray-200"
                    : ""
                }
              >
                {row.getVisibleCells().map((cell, index) => (
                  <td
                    key={cell.id}
                    className={`w-fit overflow-hidden whitespace-nowrap border-[1px] border-neutral-clr-300 px-1 text-[12px] font-medium text-[#636363] 
                         `}
                  >
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}

                    {cell.id.split("_")[1] === "main" &&
                      cell.id.split("_")[2] === "menu" &&
                      cell.id.split("_")[3] === "id" && (
                        <CellDropDown
                          cell={cell}
                          rowId={rowId}
                          valueToGet={"main_menu_id"}
                          isDropDownVisible={isDropDownVisible}
                          handleEditButton={handleEditButton}
                          setPayloadChange={setPayloadChange}
                          setEdited={setEdited}
                          setRowEdit={setRowEdit}
                          rowEdit={rowEdit}
                          setSelectedItemId={setSelectedItemId}
                          setIsDelete={setIsDelete}
                        />
                      )}

                    {cell.id.split("_")[1] === "main" &&
                      cell.id.split("_")[2] === "menu" &&
                      cell.id.split("_")[3] !== "id" && (
                        <CellDropDown
                          cell={cell}
                          rowId={rowId}
                          valueToGet={"sub_menu"}
                          isDropDownVisible={isDropDownVisible}
                          handleEditButton={handleEditButton}
                          setPayloadChange={setPayloadChange}
                          setEdited={setEdited}
                          setRowEdit={setRowEdit}
                          rowEdit={rowEdit}
                          setSelectedItemId={setSelectedItemId}
                          setIsDelete={setIsDelete}
                        />
                      )}

                    {cell.id.split("_")[1] === "sub" &&
                      cell.id.split("_")[2] === "menu" &&
                      cell.id.split("_")[3] === "id" && (
                        <CellDropDown
                          cell={cell}
                          rowId={rowId}
                          valueToGet={"sub_menu_id"}
                          isDropDownVisible={isDropDownVisible}
                          handleEditButton={handleEditButton}
                          setPayloadChange={setPayloadChange}
                          setEdited={setEdited}
                          setRowEdit={setRowEdit}
                          rowEdit={rowEdit}
                          setSelectedItemId={setSelectedItemId}
                          setIsDelete={setIsDelete}
                        />
                      )}

                    {cell.id.split("_")[1] === "sort" &&
                      cell.id.split("_")[2] === "order" && (
                        <CellDropDown
                          cell={cell}
                          rowId={rowId}
                          valueToGet={"sort_order"}
                          isDropDownVisible={isDropDownVisible}
                          handleEditButton={handleEditButton}
                          setPayloadChange={setPayloadChange}
                          setEdited={setEdited}
                          setRowEdit={setRowEdit}
                          rowEdit={rowEdit}
                          setSelectedItemId={setSelectedItemId}
                          setIsDelete={setIsDelete}
                        />
                      )}
                    {cell.id.split("_")[1] === "add" &&
                      cell.id.split("_")[2] === "perm" && (
                        <CellDropDown
                          cell={cell}
                          rowId={rowId}
                          valueToGet={"add_perm"}
                          isDropDownVisible={isDropDownVisible}
                          handleEditButton={handleEditButton}
                          setPayloadChange={setPayloadChange}
                          setEdited={setEdited}
                          setRowEdit={setRowEdit}
                          rowEdit={rowEdit}
                          setSelectedItemId={setSelectedItemId}
                          setIsDelete={setIsDelete}
                        />
                      )}

                    {cell.id.split("_")[1] === "edit" &&
                      cell.id.split("_")[2] === "perm" && (
                        <CellDropDown
                          cell={cell}
                          rowId={rowId}
                          valueToGet={"edit_perm"}
                          isDropDownVisible={isDropDownVisible}
                          handleEditButton={handleEditButton}
                          setPayloadChange={setPayloadChange}
                          setEdited={setEdited}
                          setRowEdit={setRowEdit}
                          rowEdit={rowEdit}
                          setSelectedItemId={setSelectedItemId}
                          setIsDelete={setIsDelete}
                        />
                      )}

                    {cell.id.split("_")[1] === "view" &&
                      cell.id.split("_")[2] === "perm" && (
                        <CellDropDown
                          cell={cell}
                          rowId={rowId}
                          valueToGet={"view_perm"}
                          isDropDownVisible={isDropDownVisible}
                          handleEditButton={handleEditButton}
                          setPayloadChange={setPayloadChange}
                          setEdited={setEdited}
                          setRowEdit={setRowEdit}
                          rowEdit={rowEdit}
                          setSelectedItemId={setSelectedItemId}
                          setIsDelete={setIsDelete}
                        />
                      )}

                    {cell.id.split("_")[1] === "delete" &&
                      cell.id.split("_")[2] === "perm" && (
                        <CellDropDown
                          cell={cell}
                          rowId={rowId}
                          valueToGet={"delete_perm"}
                          isDropDownVisible={isDropDownVisible}
                          handleEditButton={handleEditButton}
                          setPayloadChange={setPayloadChange}
                          setEdited={setEdited}
                          setRowEdit={setRowEdit}
                          rowEdit={rowEdit}
                          setSelectedItemId={setSelectedItemId}
                          setIsDelete={setIsDelete}
                        />
                      )}

                    {cell.id.split("_")[1] === "download" &&
                      cell.id.split("_")[2] === "perm" && (
                        <CellDropDown
                          cell={cell}
                          rowId={rowId}
                          valueToGet={"download_perm"}
                          isDropDownVisible={isDropDownVisible}
                          handleEditButton={handleEditButton}
                          setPayloadChange={setPayloadChange}
                          setEdited={setEdited}
                          setRowEdit={setRowEdit}
                          rowEdit={rowEdit}
                          setSelectedItemId={setSelectedItemId}
                          setIsDelete={setIsDelete}
                        />
                      )}

                    {cell.id.split("_")[1] === "import" &&
                      cell.id.split("_")[2] === "perm" && (
                        <CellDropDown
                          cell={cell}
                          rowId={rowId}
                          valueToGet={"import_perm"}
                          isDropDownVisible={isDropDownVisible}
                          handleEditButton={handleEditButton}
                          setPayloadChange={setPayloadChange}
                          setEdited={setEdited}
                          setRowEdit={setRowEdit}
                          rowEdit={rowEdit}
                          setSelectedItemId={setSelectedItemId}
                          setIsDelete={setIsDelete}
                        />
                      )}

                    {cell.id.split("_")[1] === "status" && (
                      <CellDropDown
                        cell={cell}
                        rowId={rowId}
                        valueToGet={"status"}
                        isDropDownVisible={isDropDownVisible}
                        handleEditButton={handleEditButton}
                        setPayloadChange={setPayloadChange}
                        setEdited={setEdited}
                        setRowEdit={setRowEdit}
                        rowEdit={rowEdit}
                        setSelectedItemId={setSelectedItemId}
                        setIsDelete={setIsDelete}
                      />
                    )}
                    {cell.id.split("_")[1] === "icons" && (
                      <CellDropDown
                        cell={cell}
                        rowId={rowId}
                        valueToGet={"icons"}
                        isDropDownVisible={isDropDownVisible}
                        handleEditButton={handleEditButton}
                        setPayloadChange={setPayloadChange}
                        setEdited={setEdited}
                        setRowEdit={setRowEdit}
                        rowEdit={rowEdit}
                        setSelectedItemId={setSelectedItemId}
                        setIsDelete={setIsDelete}
                      />
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="flex w-[160px]  items-end gap-4 ">
        <button
          onClick={() => handleSubmit()}
          className={`mt-4 w-full rounded border-2 border-pri-clr-orange bg-pri-clr-orange  py-1 font-semibold text-white ${
            payloadChanges.length < 1 || isButtonClicked?.mainMenu
              ? "opacity-[50%]"
              : ""
          } `}
          disabled={payloadChanges.length < 1 || isButtonClicked?.mainMenu}
        >
          {isButtonClicked?.mainMenu ? <MirageLoader /> : "Save Changes"}
        </button>
      </div>
    </div>
  );
};

export default AssignPermTable;
